@if (catalog) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <footer (click)="toggleFooterBubble()" [tabindex]="0">
    <span>&copy; <b>2reserve</b>.ch</span><span class="suffix"> &ndash; {{ 'FOOTER' | translate }}</span>
    @if (showConditions && settings?.ShowConditions) {
      <a [routerLink]="['/', catalog.name, currentLang(), 'terms-and-conditions']" (click)="$event.stopPropagation()">
        | {{ customLabels.checkout().TermsAndConditions || 'TERMS_AND_CONDITIONS' | translate }}</a
      >
    }
    <span> | {{ 'IMPRINT.IMPRINT' | translate }}</span>
  </footer>
}
@if (showFooterBubble()) {
  <div class="cdk-overlay-container">
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
    <div class="cdk-overlay-backdrop" [tabindex]="0" (click)="toggleFooterBubble()"></div>
    <div class="cdk-global-overlay-wrapper">
      <div class="cdk-overlay-pane">
        <div class="content-bubble bottom">
          <div class="content">
            <div class="address">
              <h3>{{ 'IMPRINT.CONTENT' | translate }}</h3>
              {{ catalog!.client.organization }}<br />
              @if (catalog!.client.address) {
                <div>{{ catalog!.client.address }}</div>
              }
              <div>{{ catalog!.client.zipcode }} {{ catalog!.client.location }}</div>
              @if (catalog!.client.website) {
                <div>
                  <a href="{{ catalog!.client.website | toHref }}" target="_blank">{{ catalog!.client.website }}</a>
                </div>
              }
              @if (catalog!.client.mail) {
                <div>
                  <a href="mailto:{{ catalog!.client.mail }}">{{ catalog!.client.mail }}</a>
                </div>
              }
              @if (catalog!.client.phone) {
                <div>
                  <a href="tel:{{ catalog!.client.phone }}">{{ catalog!.client.phone }}</a>
                </div>
              }
            </div>
            <div class="address">
              <h3>{{ 'IMPRINT.SYSTEM' | translate }}</h3>
              2sic internet solutions GmbH<br />
              Langäulistrasse 62<br />
              9470 Buchs SG<br />
              <a href="https://www.2reserve.ch" target="_blank" class="logo">
                <img src="logo.svg" alt="Logo 2reserve" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
